module.exports = __webpack_public_path__ + "img/devops.c2ace04.svg";